<ng-template
  #detailsDrawer
  bdKey="detailsDrawer"
  [bdDrawer]="detailsDrawer"
  [drawerPosition]="'right'"
  [drawerState]="contentDetailsGlobalStore.drawerState()"
>
  <bd-content-details-container
    [showSkeleton]="contentDetailsGlobalStore.contentItemDetailsLoading()"
    [contentItemDetails]="contentDetailsGlobalStore.contentItemDetails()"
    (drawerClosed)="onContentDetailsClose()"
    [scrollToUsedIn]="contentDetailsGlobalStore.scrollToUsedIn()"
    [contentDetailsConfiguration]="contentDetailsConfiguration"
    [showFooter]="contentDetailsGlobalStore.showDrawerFooter()"
    [context]="'insight'"
    (contentItemDeleted)="onContentRefresh()"
    (contentItemAddTo)="contentItemAddTo.emit($event)"
  ></bd-content-details-container>
</ng-template>
<ng-template
  #drawer
  bdKey="drawer"
  [bdDrawer]="drawer"
  [drawerState]="{ visible: contentOverviewState() === 'show' }"
  [drawerPosition]="'left'"
>
  <bd-content-overview
    [sourceQuery]="highchartsStore.sourceQuery()"
    [appliedFilters]="highchartsStore.appliedFilters()"
    [objectsList]="highchartsStore.objectsList()"
    [loading]="highchartsStore.showLoader()"
    (close)="onContentOverviewClose()"
    (contentRefresh)="onContentRefresh()"
  ></bd-content-overview>
</ng-template>

@if (refreshDialogProperties$ | async; as dialogProperties) {
  <bd-dialog
    *transloco="
      let t;
      scope: 'featureHighcharts';
      prefix: 'featureHighcharts.refreshInsightDialog'
    "
    data-id="refresh-insight-dialog"
    [visible]="contentDetailsGlobalStore.refreshInsightDialogVisible()"
    (dismiss)="contentDetailsGlobalStore.closeRefreshInsightDialog()"
    [dialogProperties]="dialogProperties"
    (confirm)="
      contentDetailsGlobalStore.closeRefreshInsightDialog(); onContentRefresh()
    "
  >
    <p class="bd-body-regular">{{ t('message') }}</p>
  </bd-dialog>
}

@if (contentDetailsGlobalStore.showDrawerBackdrop()) {
  <div
    class="drawer-backdrop"
    (click)="
      contentDetailsGlobalStore.updateShowUnsavedPublishedItemWarning(true)
    "
    (keydown)="
      contentDetailsGlobalStore.updateShowUnsavedPublishedItemWarning(true)
    "
  ></div>
}
